module.exports = __webpack_public_path__ + "img/kefu.391877aa.png";